export interface InventoryMovementRow {
  id: string
  code: string
  movementDate?: string
  remarks?: string
  sourceWarehouse: string
  destinationWarehouse: string
  attachmentFilePath?: string
}

export interface InventoryMovementLine {
  /**
   * Client-side stable key for rendering rows.
   * Backend expects numeric `id`, but we can still keep a string key for UI.
   */
  id: string

  // Master id reference (backend uses `transferId` inside the line payload)
  transferId: number

  itemId: string
  batchId: string

  fromWarehouseId: number
  toWarehouseId: number

  previousQuantity: number // current quantity at source warehouse
  quantityTransfered: number // qty to move
  newQuantity: number // balance qty at destination warehouse (or remaining after transfer)

  // Backend expects a string (historical swagger casing)
  isDeleted: string
}

export function newInventoryMovementLine(): InventoryMovementLine {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    transferId: 0,
    itemId: '',
    batchId: '',
    fromWarehouseId: 0,
    toWarehouseId: 0,
    previousQuantity: 0,
    quantityTransfered: 0,
    newQuantity: 0,
    isDeleted: 'false',
  }
}

